import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { EmployeeProfileService } from './employee-profile.service';
import { ApiCreds, rawTaxFormsNotice, TaxForm } from '../models';
import { taxFormsNoticeUrl } from './constants';
import * as utils from './utils/service.utils';
import { taxFormsNoticeCleanKeys } from './constants/cleanKeys';

@Injectable({ providedIn: 'root' })
export class TaxFormsNoticeService {
  /** Observable cache of clean  Employee Tax Forms */
  taxFormsNoticeSubject = new ReplaySubject<TaxForm>(1);
  taxFormsNotice$ = this.taxFormsNoticeSubject.asObservable();

  constructor(private profileService: EmployeeProfileService, private http: HttpClient) {
    this.refresh();
  }

  /** Fetch Data from API using Employee API Credentials */
  private fetchData(apiCreds: ApiCreds): Observable<rawTaxFormsNotice> {
    //1.  Build URL string.

    const url = `${taxFormsNoticeUrl}/${apiCreds.bcl}/${apiCreds.id}`;
    //2. Fetch URL string and create Observable with Data.
    return this.http.get<rawTaxFormsNotice>(url);
  }

  private formatTaxFormsNotice(rawTaxFormsNotice: rawTaxFormsNotice): TaxForm {
    const { Success, ErrorMessage, ...filteredData } = rawTaxFormsNotice;
    const cleanTaxFormsNotice = utils.cleanApiKeys(taxFormsNoticeCleanKeys, filteredData);

    const cleanTaxFormNotice = utils.keysToCamelCase(cleanTaxFormsNotice);

    //! We are creating a new flat object because rawTaxFormsNotice is double nested from API.
    return Object.assign({}, cleanTaxFormNotice.taxFormsNotice);
  }

  //* Fetch tax forms data from API.
  private fetchTaxFormsNotice(): Observable<TaxForm> {
    //* 1. Collect Employee Api Credentials from Profile Service.
    return this.profileService.apiCreds$.pipe(
      take(1),
      //* 2. SwitchMap to allow inner Observable & fetch Data with apiCreds
      switchMap(apiCreds => this.fetchData(apiCreds)),
      //* 3. Format data into clean Observable.
      map(taxFormsNotice => this.formatTaxFormsNotice(taxFormsNotice))
    );
  }

  refresh() {
    this.fetchTaxFormsNotice().subscribe(taxFormsNotice =>
      this.taxFormsNoticeSubject.next(taxFormsNotice)
    );
  }
}
